// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';
import { AssetToBeTransferredOrUnloadedDto } from '@ellf/common-dto';

@Injectable()
export class AssetToBeTransferredOrUnloadedApiClient extends BaseCRUDApiClient<AssetToBeTransferredOrUnloadedDto> {
  baseUrl = this.config.apiEndpoint + '/asset-to-be-transferred-or-unloaded';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
